import { sha256 } from "js-sha256";

export function sha256Hash(value: string) {
  return sha256(value);
}
